module.exports = {
	EVENT_CONNECTED: "connected",
	EVENT_DISCONNECTED: "disconnected"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/roslib-client/src/Constants.js
// module id = 170
// module chunks = 0